var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center w-full bg-black text-white pt-3 pb-4 text-sm rounded-full",on:{"click":_vm.onClick}},[(_vm.loading)?_c('Spinner'):_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }